import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/ui/BannerSection';
import InstituicaoMenu from '../../components/ui/InstituicaoMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Legalidade' }
];

function Legalidade() {
    return (
        <div>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
            title="Fundamento Legal da Instituição"
            subtitle="Normas e Regulamentações"
            description={`O Instituto Superior Politécnico Atlântida opera dentro de um quadro legal sólido, garantindo a conformidade com as normas e regulamentos educacionais vigentes.`}
            backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
            backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        <div className="details-magazine">
                            <p className="f-reg">
                                <SectionHeading title="Legalidade" />
                                <p>
                                    A nossa instituição está devidamente legalizada e reconhecida pelas autoridades competentes, cumprindo todas as exigências legais para o seu funcionamento. Atuamos com transparência e compromisso, garantindo a qualidade dos nossos serviços educacionais.
                                </p>
                                <br />
                                <p className="f-reg text-center">
                                    <a href="# " className="mb-3 text-ispa d-block">Legalidade da instituição: Decreto Nº 168/12 de 24 de Julho</a>
                                    <a href="# " className="mb-3 text-ispa d-block">Legalidade dos Cursos: Decreto Nº 433/12 de 24 de Outubro</a>
                                    <a href="# " className="mb-3 text-ispa d-block">Legalidade dos Cursos (Derrogado): Nº Decreto 437/17 de 29 de Setembro</a>
                                </p>
                            </p>
                        </div>
                        <br /><br />
                    </div>
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2">
                        <InstituicaoMenu />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </main>
            <AppLayout />
        </div>
    );
}

export default Legalidade;
